import { testimonials, trustBadges } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-chat-heart-line text-accent-600 text-sm"></i>
            </span>
            <span className="text-foreground-600 text-xs font-medium whitespace-nowrap">Community</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Was unsere Nutzer sagen
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            Echte Erfahrungen von OOPBUY Spreadsheet Nutzern aus Deutschland
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="flex flex-col p-6 bg-white rounded-lg border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{t.name}</p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">{t.role}</p>
                </div>
              </div>
              <div className="mb-3">
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-accent-400 text-lg"></i>
                </span>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                {t.text}
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustBadges.map((badge) => (
            <div
              key={badge.title}
              className="flex flex-col items-center text-center p-5 bg-white rounded-lg border border-background-200/70"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className={`${badge.icon} text-lg`}></i>
              </span>
              <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{badge.title}</h4>
              <p className="text-xs text-foreground-500 whitespace-nowrap">{badge.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}